export default __webpack_public_path__ + "4a270aaad788c3d17810b23fdd97eddb.png";